import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { formatINR } from "@/lib/brand";
import { toast } from "sonner";

const STATUSES = ["pending","confirmed","processing","shipped","delivered","cancelled","returned"];

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const load = useCallback(() => api.get("/admin/orders").then(r => setOrders(r.data)), []);
  useEffect(() => { load(); }, [load]);
  const update = async (id, status) => {
    try { await api.patch(`/admin/orders/${id}/status`, { status }); toast.success("Updated"); load(); }
    catch { toast.error("Failed"); }
  };
  return (
    <div>
      <p className="text-[10px] tracking-luxury uppercase text-gold mb-4">Fulfilment</p>
      <h1 className="font-editorial text-5xl mb-16 tracking-tight">Orders</h1>
      <div className="border border-ivory/10">
        <div className="grid grid-cols-12 py-4 px-6 text-[10px] tracking-widest-plus uppercase text-ivory/50 border-b border-ivory/10">
          <div className="col-span-2">Order</div>
          <div className="col-span-4">Client</div>
          <div className="col-span-2">Total</div>
          <div className="col-span-2">Payment</div>
          <div className="col-span-2">Status</div>
        </div>
        {orders.length === 0 && <p className="p-8 text-center text-ivory/40 font-editorial-italic">No orders yet.</p>}
        {orders.map(o => (
          <div key={o.id} data-testid={`admin-order-${o.id.slice(0,8)}`} className="grid grid-cols-12 py-3 px-6 items-center border-b border-ivory/5 text-sm">
            <div className="col-span-2 font-editorial text-lg">#{o.id.slice(0,8).toUpperCase()}</div>
            <div className="col-span-4 text-ivory/80">{o.email}</div>
            <div className="col-span-2">{formatINR(o.total)}</div>
            <div className={`col-span-2 text-[10px] tracking-widest-plus uppercase ${o.payment_status === "paid" ? "text-gold" : "text-ivory/50"}`}>{o.payment_status}</div>
            <div className="col-span-2">
              <select value={o.status} onChange={(e)=>update(o.id, e.target.value)} className="bg-transparent border border-ivory/20 py-1 px-2 text-xs uppercase tracking-widest">
                {STATUSES.map(s => <option key={s} value={s} className="bg-ink">{s}</option>)}
              </select>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
